import type Store from '~/types/Store';

import { type ActionTypes } from '~/actions';
import { ActionKeys } from '~/actions/constants';

export type StoresState = {
  readonly data: { [storeId: string]: Readonly<Store> };
  readonly isLoaded: boolean;
};

const initialState: StoresState = {
  data: {},
  isLoaded: false,
};

const reducer = (state: StoresState = initialState, action: ActionTypes): StoresState => {
  switch (action.type) {
    case ActionKeys.STORES_FETCH_SUCCESS:
      return {
        data: action.payload.stores.reduce(
          (obj, store: Store) => ({ ...obj, [store.objectId]: store }),
          {},
        ),
        isLoaded: true,
      };
    default:
      return state;
  }
};

export default reducer;
